import React from 'react'
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom'
import { withUserStore } from '../../contexts/UserStore'
import Lex from '../Shared/Lex'
import TabNav from '../Shared/TabNav'
import ProfileInfo from './ProfileInfo'
import SecuritySettings from './SecuritySettings'
import ConnectedDevices from './ConnectedDevices'

const ProfileContainer = ({ userStore }) => {
  const navigate = useNavigate()
  const location = useLocation()

  const isActive = (path) => {
    if (path === 'profile') return location.pathname === '/app/profile'
    return location.pathname.startsWith(`/app/${path}`)
  }

  const tabs = [
    { key: 'profile', label: <Lex term="profile-information" />, onClick: () => navigate('/app/profile'), active: isActive('profile') },
    { key: 'security', label: <Lex term="security-settings" />, onClick: () => navigate('/app/profile/security'), active: isActive('profile/security') },
    { key: 'devices', label: <Lex term="connected-devices" />, onClick: () => navigate('/app/profile/devices'), active: isActive('profile/devices') },
  ]

  return (
    <div className="container proxima-nova">
      <h5 className="text-center"><Lex term="profile-settings" /></h5>
      <div className="cbs-scope">
        <TabNav tabs={tabs} />
      </div>
      <div className="main-content">
        <Routes>
          <Route path="/" element={<ProfileInfo userStore={userStore} />} />
          <Route path="security" element={<SecuritySettings userStore={userStore} />} />
          <Route path="devices" element={<ConnectedDevices userStore={userStore} />} />
        </Routes>
      </div>
    </div>
  )
}

export default withUserStore(ProfileContainer)
